// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NwNZ7wCGeJnuc4JPKs8E9","filterTags":"efXftiY3WcklWuolES3fD","sliderFilters":"_3AGzSPFBiNe79kW0ujOsmU"};